/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/license-agreement'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import UserAgreement from '@routes/StaticPages/LegalPages/UserAgreement';

export const Route = createFileRoute('/license-agreement')({
  component: () => (
    <CacheDataRoute component={UserAgreement} path='/license-agreement' />
  )
});
